import React from 'react'
import styled from '@emotion/styled'

import InnerHtml from '@peracto/peracto-editor-ui/dist/InnerHtml'

// The child selectors below carry Emotion's SSR opt-out flag. The children are CMS HTML injected with
// dangerouslySetInnerHTML, and Emotion only inserts its SSR <style> tags next to the styled element,
// never inside it, so the first/last child can never be a style tag. The "of-type" alternatives
// would change the layout: they match the first paragraph, the first heading and the first list.
// (Kept out of the CSS because Emotion scans CSS comments for these selectors too.)
const Text = styled(InnerHtml)`
    overflow: auto;
    border: 1px solid transparent;
    margin: ${props => {
        switch (props.blockalignment) {
            case 'center':
                return `0 auto`
            case 'right':
                return `0 0 0 auto`
            default:
                return `0 auto 0 0`
        }
    }};

    > :last-child /* emotion-disable-server-rendering-unsafe-selector-warning-please-do-not-use-this-the-warning-exists-for-a-reason */ {
        margin-bottom: 0;
    }
`

const AccordionContent = ({ content }) => {
    return <Text content={content} className="content__text" />
}

export default AccordionContent
